import { ACTIVE_EXPERIMENTS } from '$lib/services/experiments/client/constants';
import { experimentClient } from '$lib/services/experiments/client_v2';
import { app } from '$lib/stores/app/store';
import { get } from 'svelte/store';
import { LINK_FROM_APP_PLATFORMS } from '$lib/utils/constants';

const isLinkFrom1_0App = () => {
	const { linkFromAppPlatform } = get(app).global;
	return (
		linkFromAppPlatform === LINK_FROM_APP_PLATFORMS.IOS_1_0 ||
		linkFromAppPlatform === LINK_FROM_APP_PLATFORMS.ANDROID_1_0
	);
};

/**
 * @type {{[key: string]: import('$lib/utils/page').PageCondition}}
 */
const pageConditions = {
	oauthChoiceExperiment: {
		condition: async () => {
			if (isLinkFrom1_0App()) return false;
			await Promise.all([
				experimentClient.initializeExperiment(
					ACTIVE_EXPERIMENTS.ABCM2_THIRD_PARTY_AUTH_WEB.experimentKey
				),
				experimentClient.initializeExperiment(
					ACTIVE_EXPERIMENTS.ABCM2_THIRD_PARTY_AUTH_APP.experimentKey
				),
			]);
			const isWebTest = experimentClient.isVariantActive(
				ACTIVE_EXPERIMENTS.ABCM2_THIRD_PARTY_AUTH_WEB.experimentKey,
				ACTIVE_EXPERIMENTS.ABCM2_THIRD_PARTY_AUTH_WEB.variants.test
			);
			const isAppTest = experimentClient.isVariantActive(
				ACTIVE_EXPERIMENTS.ABCM2_THIRD_PARTY_AUTH_APP.experimentKey,
				ACTIVE_EXPERIMENTS.ABCM2_THIRD_PARTY_AUTH_APP.variants.test
			);
			return isWebTest || isAppTest;
		},
		resolve: async () => await import('../_browser-oauth-choice/Page.svelte'),
	},
	default: {
		condition: async () => true,
		resolve: async () => await import('../_browser/Page.svelte'),
	},
};

export { pageConditions };
